(function($){
    var appearDistance = '90%';
  if($('.gallery')[0]) {
    var clinicWaypoint = new Waypoint({
      element: $('.gallery'),
      handler: function(direction) {
        $('.gallery').animateCSS();
      },
      offset: appearDistance
    });
  }

  if($('.gallery__items')[0]) {
    var galleryWaypoint = new Waypoint({
      element: $('.gallery__items'),
      handler: function(direction) {
        $('.gallery__items a').animateCSS({stepDelay: 200});
      },
      offset: '75%'
    });
  }

}(jQuery));